import React from 'react';
import { Helmet } from 'react-helmet-async';

import { Typography } from 'antd';
import { HomeOutlined } from '@ant-design/icons';

const ClientHomePage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Client Home | Mabel</title>
      </Helmet>
      <Typography.Title level={3}>
        <HomeOutlined /> Client Home
      </Typography.Title>
    </>
  );
};

export default ClientHomePage;
